// "Bold, darker text" user setting (Configurator). Off keeps the original Flow look; on applies the
// heavier, darker text closers asked for on their small, older monitors.
import { Theme, createTheme } from "@mui/material/styles";

const BOLD_WEIGHT = 500;
const BOLD_COLOR = "#000";
const BOLD_LINK_STYLE = { color: "#0b2e6b", fontWeight: 600 };
const BOLD_MUTED_COLOR = "#333";

// Light theme with the regular weight raised 400 -> 500 and primary text full black. The tab, tooltip
// and step label overrides bake the regular weight in when the base theme is built, so they are
// raised here as well.
export const withBoldText = (theme: Theme): Theme =>
  createTheme(theme, {
    palette: { text: { primary: "#000000" } },
    typography: {
      fontWeightRegular: BOLD_WEIGHT,
      body1: { fontWeight: BOLD_WEIGHT },
    },
    components: {
      MuiTab: { styleOverrides: { root: { fontWeight: BOLD_WEIGHT } } },
      MuiTooltip: { styleOverrides: { tooltip: { fontWeight: BOLD_WEIGHT } } },
      MuiStepLabel: {
        styleOverrides: {
          label: {
            fontWeight: BOLD_WEIGHT,
            "&.Mui-active": { fontWeight: `${BOLD_WEIGHT} !important` },
            "&.Mui-completed": { fontWeight: `${BOLD_WEIGHT} !important` },
          },
        },
      },
    },
  });

// Weight and color for grid and body text; `off` is what the screen used before the setting existed.
export const readableText = (on: boolean, off: { fontWeight?: number; color?: string } = {}) =>
  on ? { fontWeight: BOLD_WEIGHT, color: BOLD_COLOR } : off;

// Trip number, phone and point links in the grids; off leaves the browser-default link style.
export const readableLink = (on: boolean) => (on ? BOLD_LINK_STYLE : undefined);

// Grey secondary text (placeholders, GPS sub-lines, labels); off is that spot's original grey.
export const readableMuted = (on: boolean, off: string) => (on ? BOLD_MUTED_COLOR : off);

// The Show-in-map icon: dark navy when on, the theme info color when off.
export const readableIconColor = (on: boolean) => (on ? BOLD_LINK_STYLE.color : "info.main");
